import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { bannerApi } from '../../config/api.config';
import useUserStore from '../../store/useUserStore';
import Loading from '../common/Loading';
import BannerModal from './BannerModal';
import BannerEditModal from './BannerEditModal';

const BannerList = () => {
    const nav = useNavigate();
    const { userToken, isTokenValid } = useUserStore();
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editingBanner, setEditingBanner] = useState(null);
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    const [previewBanner, setPreviewBanner] = useState(null);

    useEffect(() => {
        if (!userToken || !isTokenValid()) {
            alert('관리자 권한이 없습니다.');
            nav('/login');
            return;
        }
    }, [userToken, isTokenValid, nav]);

    useEffect(() => {
        setLoading(true);
        bannerApi.get(`/admin`)
            .then(res => {
                console.log(res.data);
                setBanners(res.data || []);
                setLoading(false);
            }).catch(err => {
                console.log(err);
                setLoading(false);
            })
    }, []);

    const handleToggleActive = (bannerId, currentStatus) => {
        const newStatus = !currentStatus;
        
        console.log('비활성화 토글:', bannerId, currentStatus, '->', newStatus);
        
        // JSON으로 전송하는 방식으로 변경
        bannerApi.patch(`/admin/${bannerId}`, {
            isActive: newStatus
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(() => {
                // 해당 배너의 활성화 상태만 토글
                setBanners(banners.map(banner => ({
                    ...banner,
                    isActive: banner.id === bannerId ? newStatus : banner.isActive
                })));
            })
            .catch(err => {
                console.log(err);
                alert('상태 변경에 실패했습니다.');
            });
    };

    const handleEdit = (banner) => {
        setEditingBanner(banner);
        setIsEditModalOpen(true);
    };

    const handlePreview = (banner) => {
        setPreviewBanner(banner);
        setIsPreviewModalOpen(true);
    };

    const handleDelete = (bannerId) => {
        if(window.confirm('정말로 삭제하시겠습니까?')) {
            bannerApi.delete(`/admin/${bannerId}`)
                .then(() => {
                    setBanners(banners.filter(banner => banner.id !== bannerId));
                })
                .catch(err => {
                    console.log(err);
                    alert('삭제에 실패했습니다.');
                });
        }
    };

    const handleOrderChange = (newOrder) => {
        const ids = newOrder.map(banner => banner.id);
        
        bannerApi.patch('/admin/order', { ids })
            .then(() => {
                setBanners(newOrder);
            })
            .catch(err => {
                console.log(err);
                alert('순서 변경에 실패했습니다.');
            });
    };

    const moveBanner = (fromIndex, toIndex) => {
        const newBanners = [...banners];
        const [movedBanner] = newBanners.splice(fromIndex, 1);
        newBanners.splice(toIndex, 0, movedBanner);
        
        // 순서 번호 업데이트
        const updatedBanners = newBanners.map((banner, index) => ({
            ...banner,
            sortOrder: index + 1
        }));
        
        handleOrderChange(updatedBanners);
    };

    if (!userToken || !isTokenValid()) {
        return null;
    }

    if (loading) {
        return <Loading text="배너 목록을 불러오는 중..." />;
    }

    return (
        <div style={{ maxWidth: 1200, margin: '40px auto 0 auto', padding: '0 16px' }}>
            <h2 style={{ fontSize: 24, fontWeight: 700, borderBottom: '2px solid #1976d2', paddingBottom: 8, color: '#222', margin: 0 }}>
                배너 관리
            </h2>
            
            <div style={{
                background: '#f5f5f5',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                padding: '12px 16px',
                marginTop: '16px',
                fontSize: '14px',
                color: '#666'
            }}>
                <div style={{ fontWeight: '500', marginBottom: '4px', color: '#333' }}>
                    💡 배너 관리 안내
                </div>
                <div style={{ lineHeight: '1.4' }}>
                    • <strong>순서 변경:</strong> 각 배너의 "↑ 위로", "↓ 아래로" 버튼을 클릭하여 순서를 변경할 수 있습니다.<br/>
                    • <strong>수정:</strong> "수정" 버튼을 클릭하여 배너 정보와 이미지를 변경할 수 있습니다.<br/>
                    • <strong>활성화/비활성화:</strong> "활성화됨" 또는 "비활성화" 버튼을 클릭하여 배너 상태를 변경할 수 있습니다.<br/>
                    • <strong>삭제:</strong> "삭제" 버튼을 클릭하여 배너를 완전히 제거할 수 있습니다.
                </div>
            </div>
            
            <div style={{ minHeight: 220 }}>
                {banners.length > 0 ? (
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                        gap: '20px',
                        marginTop: '20px'
                    }}>
                        {banners
                            .sort((a, b) => a.sortOrder - b.sortOrder)
                            .map((banner, index) => (
                            <div
                                key={banner.id}
                                style={{
                                    border: banner.isActive ? '3px solid #1976d2' : '1px solid #ddd',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    backgroundColor: 'white',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                <div style={{
                                    position: 'relative',
                                    width: '100%',
                                    height: '200px',
                                    overflow: 'hidden'
                                }}>
                                    <img
                                        src={banner.imageUrl}
                                        alt={banner.title || banner.fileName}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover'
                                        }}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.nextSibling.style.display = 'flex';
                                        }}
                                    />
                                    <div
                                        style={{
                                            display: 'none',
                                            width: '100%',
                                            height: '100%',
                                            backgroundColor: '#f5f5f5',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#666',
                                            fontSize: '14px'
                                        }}
                                    >
                                        이미지를 불러올 수 없습니다
                                    </div>
                                    
                                </div>
                                
                                <div style={{ padding: '16px' }}>
                                    <div style={{
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        color: '#333',
                                        marginBottom: '4px'
                                    }}>
                                        {banner.title}
                                    </div>
                                        <div style={{
                                            fontSize: '14px',
                                            color: '#666',
                                            marginBottom: '12px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            flexWrap: 'wrap'
                                        }}>
                                            <span style={{
                                                background: '#1976d2',
                                                color: 'white',
                                                padding: '4px 8px',
                                                borderRadius: '6px',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                whiteSpace: 'nowrap'
                                            }}>
                                                #{banner.sortOrder}
                                            </span>
                                            <span style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '4px',
                                                fontSize: '13px',
                                                fontWeight: '500',
                                                whiteSpace: 'nowrap'
                                            }}>
                                                <span style={{
                                                    fontSize: '14px'
                                                }}>
                                                    📍
                                                </span>
                                                <span style={{
                                                    background: banner.placement === 'home_top' ? '#4caf50' : 
                                                               banner.placement === 'search_result' ? '#ff9800' : '#9c27b0',
                                                    color: 'white',
                                                    padding: '3px 8px',
                                                    borderRadius: '6px',
                                                    fontSize: '10px',
                                                    fontWeight: 'bold',
                                                    whiteSpace: 'nowrap'
                                                }}>
                                                    {banner.placement === 'home_top' ? '홈 상단' :
                                                     banner.placement === 'search_result' ? '검색 결과' :
                                                     banner.placement === 'category' ? '카테고리' : banner.placement}
                                                </span>
                                            </span>
                                        </div>
                                    <div style={{
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        color: banner.isActive ? '#1976d2' : '#d32f2f',
                                        marginBottom: '8px',
                                        padding: '2px 6px',
                                        backgroundColor: banner.isActive ? '#e3f2fd' : '#ffebee',
                                        borderRadius: '4px',
                                        display: 'inline-block'
                                    }}>
                                        {banner.isActive ? '✓ 활성화됨' : '✗ 비활성화됨'}
                                    </div>
                                    {banner.linkUrl && (
                                        <div style={{
                                            fontSize: '12px',
                                            color: '#1976d2',
                                            marginBottom: '8px',
                                            wordBreak: 'break-all'
                                        }}>
                                            링크: {banner.linkUrl}
                                        </div>
                                    )}
                                    
                                    {/* 순서 변경 버튼과 미리보기 */}
                                    <div style={{
                                        display: 'flex',
                                        gap: '12px',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        marginBottom: '12px'
                                    }}>
                                        <div style={{
                                            display: 'flex',
                                            gap: '6px',
                                            alignItems: 'center'
                                        }}>
                                            <span style={{
                                                fontSize: '10px',
                                                color: '#666',
                                                fontWeight: '500'
                                            }}>
                                                순서 변경:
                                            </span>
                                            {index > 0 && (
                                                <button
                                                    style={{
                                                        padding: '6px 10px',
                                                        background: '#1976d2',
                                                        color: '#fff',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        fontSize: '11px',
                                                        fontWeight: '500',
                                                        transition: 'all 0.2s',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '4px'
                                                    }}
                                                    onClick={() => moveBanner(index, index - 1)}
                                                    title="위로 이동"
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.background = '#1565c0';
                                                        e.currentTarget.style.transform = 'translateY(-1px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.background = '#1976d2';
                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                    }}
                                                >
                                                    ↑ 위로
                                                </button>
                                            )}
                                            {index < banners.length - 1 && (
                                                <button
                                                    style={{
                                                        padding: '6px 10px',
                                                        background: '#1976d2',
                                                        color: '#fff',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        fontSize: '11px',
                                                        fontWeight: '500',
                                                        transition: 'all 0.2s',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '4px'
                                                    }}
                                                    onClick={() => moveBanner(index, index + 1)}
                                                    title="아래로 이동"
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.background = '#1565c0';
                                                        e.currentTarget.style.transform = 'translateY(-1px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.background = '#1976d2';
                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                    }}
                                                >
                                                    ↓ 아래로
                                                </button>
                                            )}
                                        </div>
                                        
                                        {/* 미리보기 버튼 */}
                                        <button
                                            style={{
                                                padding: '6px 12px',
                                                background: '#2196f3',
                                                color: '#fff',
                                                border: '1px solid #2196f3',
                                                borderRadius: '6px',
                                                cursor: 'pointer',
                                                fontSize: '11px',
                                                fontWeight: '500',
                                                transition: 'background 0.2s, color 0.2s',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '4px'
                                            }}
                                            onMouseOver={e => {
                                                e.currentTarget.style.background = '#fff';
                                                e.currentTarget.style.color = '#2196f3';
                                                e.currentTarget.style.border = '1px solid #2196f3';
                                            }}
                                            onMouseOut={e => {
                                                e.currentTarget.style.background = '#2196f3';
                                                e.currentTarget.style.color = '#fff';
                                                e.currentTarget.style.border = '1px solid #2196f3';
                                            }}
                                            onClick={() => handlePreview(banner)}
                                        >
                                            🔍 이미지보기
                                        </button>
                                    </div>
                                    
                                    {/* 관리 버튼들 */}
                                    <div style={{
                                        display: 'flex',
                                        gap: '8px',
                                        justifyContent: 'center'
                                    }}>
                                        <button
                                            style={{
                                                padding: '8px 16px',
                                                background: '#ff9800',
                                                color: '#fff',
                                                border: '1px solid #ff9800',
                                                borderRadius: 4,
                                                cursor: 'pointer',
                                                fontSize: 12,
                                                fontWeight: '500',
                                                transition: 'background 0.2s, color 0.2s',
                                                flex: 1
                                            }}
                                            onMouseOver={e => {
                                                e.currentTarget.style.background = '#fff';
                                                e.currentTarget.style.color = '#ff9800';
                                                e.currentTarget.style.border = '1px solid #ff9800';
                                            }}
                                            onMouseOut={e => {
                                                e.currentTarget.style.background = '#ff9800';
                                                e.currentTarget.style.color = '#fff';
                                                e.currentTarget.style.border = '1px solid #ff9800';
                                            }}
                                            onClick={() => handleEdit(banner)}
                                        >
                                            수정
                                        </button>
                                        <button
                                            style={{
                                                padding: '8px 16px',
                                                background: banner.isActive ? '#d32f2f' : '#1976d2',
                                                color: '#fff',
                                                border: `1px solid ${banner.isActive ? '#d32f2f' : '#1976d2'}`,
                                                borderRadius: 4,
                                                cursor: 'pointer',
                                                fontSize: 12,
                                                fontWeight: '500',
                                                transition: 'background 0.2s, color 0.2s',
                                                flex: 1
                                            }}
                                            onMouseOver={e => {
                                                e.currentTarget.style.background = '#fff';
                                                e.currentTarget.style.color = banner.isActive ? '#d32f2f' : '#1976d2';
                                                e.currentTarget.style.border = `1px solid ${banner.isActive ? '#d32f2f' : '#1976d2'}`;
                                            }}
                                            onMouseOut={e => {
                                                e.currentTarget.style.background = banner.isActive ? '#d32f2f' : '#1976d2';
                                                e.currentTarget.style.color = '#fff';
                                                e.currentTarget.style.border = `1px solid ${banner.isActive ? '#d32f2f' : '#1976d2'}`;
                                            }}
                                            onClick={() => handleToggleActive(banner.id, banner.isActive)}
                                        >
                                            {banner.isActive ? '비활성화' : '활성화'}
                                        </button>
                                        <button
                                            style={{
                                                padding: '8px 16px',
                                                background: '#d32f2f',
                                                color: '#fff',
                                                border: '1px solid #d32f2f',
                                                borderRadius: 4,
                                                cursor: 'pointer',
                                                fontSize: 12,
                                                fontWeight: '500',
                                                transition: 'background 0.2s, color 0.2s',
                                                flex: 1
                                            }}
                                            onMouseOver={e => {
                                                e.currentTarget.style.background = '#fff';
                                                e.currentTarget.style.color = '#d32f2f';
                                                e.currentTarget.style.border = '1px solid #d32f2f';
                                            }}
                                            onMouseOut={e => {
                                                e.currentTarget.style.background = '#d32f2f';
                                                e.currentTarget.style.color = '#fff';
                                                e.currentTarget.style.border = '1px solid #d32f2f';
                                            }}
                                            onClick={() => handleDelete(banner.id)}
                                        >
                                            삭제
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div style={{
                        textAlign: 'center',
                        padding: '40px 20px',
                        color: '#666',
                        fontSize: '14px'
                    }}>
                        등록된 배너가 없습니다.
                    </div>
                )}
                
                <div style={{ textAlign: 'right', marginTop: 20 }}>
                    <button
                        style={{
                            background: '#1976d2',
                            color: '#fff',
                            border: '1px solid #1976d2',
                            borderRadius: 4,
                            padding: '8px 20px',
                            fontSize: 15,
                            fontWeight: 500,
                            cursor: 'pointer',
                            transition: 'background 0.2s, color 0.2s',
                        }}
                        onMouseOver={e => {
                            e.currentTarget.style.background = '#fff';
                            e.currentTarget.style.color = '#1976d2';
                            e.currentTarget.style.border = '1px solid #1976d2';
                        }}
                        onMouseOut={e => {
                            e.currentTarget.style.background = '#1976d2';
                            e.currentTarget.style.color = '#fff';
                            e.currentTarget.style.border = '1px solid #1976d2';
                        }}
                        onClick={() => setIsModalOpen(true)}
                    >
                        추가
                    </button>
                </div>
            </div>
            
            <BannerModal 
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSuccess={() => {
                    // 배너 추가 후 목록 새로고침
                    bannerApi.get(`/admin`)
                        .then(res => {
                            setBanners(res.data || []);
                        })
                        .catch(err => {
                            console.log(err);
                        });
                }}
            />
            
            <BannerEditModal
                isOpen={isEditModalOpen}
                onClose={() => {
                    setIsEditModalOpen(false);
                    setEditingBanner(null);
                }}
                banner={editingBanner}
                onSuccess={() => {
                    // 배너 수정 후 목록 새로고침
                    bannerApi.get(`/admin`)
                        .then(res => {
                            setBanners(res.data || []);
                        })
                        .catch(err => {
                            console.log(err);
                        });
                }}
            />
            
            {/* 배너 미리보기 모달 */}
            {isPreviewModalOpen && previewBanner && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 2000,
                    padding: '20px'
                }}
                onClick={() => {
                    setIsPreviewModalOpen(false);
                    setPreviewBanner(null);
                }}>
                    <div style={{
                        position: 'relative',
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
                    }}
                    onClick={(e) => e.stopPropagation()}>
                        {/* 닫기 버튼 */}
                        <button
                            onClick={() => {
                                setIsPreviewModalOpen(false);
                                setPreviewBanner(null);
                            }}
                            style={{
                                position: 'absolute',
                                top: '15px',
                                right: '15px',
                                background: 'rgba(0, 0, 0, 0.7)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '40px',
                                height: '40px',
                                fontSize: '20px',
                                cursor: 'pointer',
                                zIndex: 10,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            ×
                        </button>
                        
                        {/* 배너 이미지 */}
                        <img
                            src={previewBanner.imageUrl}
                            alt={previewBanner.title}
                            style={{
                                width: '100%',
                                maxHeight: '70vh',
                                objectFit: 'contain',
                                display: 'block'
                            }}
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'flex';
                            }}
                        />
                        
                        {/* 이미지 로드 실패 시 표시 */}
                        <div
                            style={{
                                display: 'none',
                                width: '100%',
                                height: '300px',
                                backgroundColor: '#f5f5f5',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#666',
                                fontSize: '16px'
                            }}
                        >
                            이미지를 불러올 수 없습니다
                        </div>
                        
                        {/* 배너 정보 */}
                        <div style={{
                            padding: '20px',
                            borderTop: '1px solid #eee'
                        }}>
                            <h3 style={{
                                margin: '0 0 10px 0',
                                fontSize: '18px',
                                fontWeight: 'bold',
                                color: '#333'
                            }}>
                                {previewBanner.title}
                            </h3>
                            
                            <div style={{
                                display: 'flex',
                                gap: '12px',
                                alignItems: 'center',
                                marginBottom: '10px'
                            }}>
                                <span style={{
                                    background: '#1976d2',
                                    color: 'white',
                                    padding: '4px 8px',
                                    borderRadius: '6px',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                }}>
                                    #{previewBanner.sortOrder}
                                </span>
                                
                                <span style={{
                                    background: previewBanner.placement === 'home_top' ? '#4caf50' : 
                                               previewBanner.placement === 'search_result' ? '#ff9800' : '#9c27b0',
                                    color: 'white',
                                    padding: '4px 10px',
                                    borderRadius: '6px',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                }}>
                                    📍 {previewBanner.placement === 'home_top' ? '홈 상단' :
                                         previewBanner.placement === 'search_result' ? '검색 결과' :
                                         previewBanner.placement === 'category' ? '카테고리' : previewBanner.placement}
                                </span>
                                
                                <span style={{
                                    background: previewBanner.isActive ? '#e3f2fd' : '#ffebee',
                                    color: previewBanner.isActive ? '#1976d2' : '#d32f2f',
                                    padding: '4px 8px',
                                    borderRadius: '6px',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                }}>
                                    {previewBanner.isActive ? '✓ 활성화됨' : '✗ 비활성화됨'}
                                </span>
                            </div>
                            
                            {previewBanner.linkUrl && (
                                <div style={{
                                    fontSize: '14px',
                                    color: '#1976d2',
                                    wordBreak: 'break-all'
                                }}>
                                    🔗 링크: {previewBanner.linkUrl}
                                </div>
                            )}
                            
                            <div style={{
                                fontSize: '12px',
                                color: '#666',
                                marginTop: '10px'
                            }}>
                                생성일: {new Date(previewBanner.createdAt).toLocaleString('ko-KR')}
                                {previewBanner.updatedAt !== previewBanner.createdAt && (
                                    <span> | 수정일: {new Date(previewBanner.updatedAt).toLocaleString('ko-KR')}</span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default BannerList
